import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Button, Textarea } from "../Form";
import { DinamicInputWithSearchBar2 } from "../Form";
import {
  FaArrowRight,
  FaArrowLeft,
  FaSave,
  FaTimesCircle,
} from "react-icons/fa";
import toast from "react-hot-toast";
import { BiChevronDown } from "react-icons/bi";
import { DrawableImagePoints, BodyOverlayViewer } from "../Drawer/DrawerImage";
import { updateVisitasById } from "../../redux/features/visitasSlice";
import ConfirmationAlert from "../ConfirmationAlert";
import { isUndefined } from "lodash";
import { useViewType } from "../../utils/ViewState";
import { Enfermedades } from "../../components/EnfermedadesCIE";

export const DivCorporal = ({ visita, setVisita, functions }) => {
  const [isBack, setIsBack] = useState(false);
  const isFemn = visita?.patient?.persona.sexo === "Femenino";
  const [openSubModal, setOpenSubModal] = useState(false);
  const [selectPart, setSelectPart] = useState(null);
  const [points, setPoints] = useState([]);
  const [sizeImage, setSizeImage] = useState({ width: 0, height: 0 });
  const [url, setUrl] = useState("");
  const view = useViewType();
  const styles = {
    bodyContainer: {
      position: "relative",
      display: "inline-block",
    },
    sector: {
      position: "absolute",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "Arial, sans-serif",
      fontSize: "14px",
      backgroundColor: "rgba(255, 255, 255, 0.3)",
      zIndex: 2,
    },
  };

  let bodyParts = {};
  if (isBack) {
    if (view) {
      bodyParts = {
        CABEZA: {
          left: "46%",
          top: isFemn ? "23%" : "20%",
          width: "9%",
          height: isFemn ? "10%" : "12%",
        },
        TORSO: {
          left: isFemn ? "46%" : "46%",
          top: isFemn ? "32.5%" : "32%",
          width: isFemn ? "9%" : "9%",
          height: isFemn ? "15%" : "15%",
        },
        BRAZO_IZQUIERDO: {
          left: isFemn ? "41%" : "41%",
          top: isFemn ? "31%" : "32%",
          width: isFemn ? "5%" : "6%",
          height: "18%",
        },
        BRAZO_DERECHO: {
          left: isFemn ? "54%" : "54%",
          top: isFemn ? "31%" : "32%",
          width: isFemn ? "5%" : "6%",
          height: "18%",
        },
        MANO_IZQUIERDA: {
          left: "40%",
          top: isFemn ? "49%" : "50%",
          width: "4.5%",
          height: "7%",
        },
        MANO_DERECHA: {
          left: isFemn ? "57%" : "57%",
          top: isFemn ? "49%" : "50%",
          width: "4%",
          height: "7%",
        },
        PIERNA_IZQUIERDA: {
          left: "45%",
          top: isFemn ? "45%" : "47%",
          width: "6%",
          height: isFemn ? "32%" : "33%",
        },
        PIERNA_DERECHA: {
          left: "51%",
          top: isFemn ? "45%" : "47%",
          width: "5%",
          height: isFemn ? "32%" : "33%",
        },
        PIE_IZQUIERDO: {
          left: "45%",
          top: isFemn ? "77%" : "80%",
          width: "6%",
          height: isFemn ? "6%" : "5%",
        },
        PIE_DERECHO: {
          left: "51%",
          top: isFemn ? "77%" : "80%",
          width: "6%",
          height: isFemn ? "6%" : "5%",
        },
      };
    } else {
      bodyParts = {
        CABEZA: {
          left: isFemn ? "42%" : "38%",
          top: isFemn ? "30%" : "28%",
          width: isFemn ? "17%" : "25%",
          height: isFemn ? "9%" : "11%",
        },
        TORSO: {
          left: isFemn ? "39%" : "38%",
          top: "39%",
          width: isFemn ? "23%" : "26%",
          height: isFemn ? "11%" : "13%",
        },
        BRAZO_IZQUIERDO: {
          left: isFemn ? "24%" : "22%",
          top: "39%",
          width: isFemn ? "15%" : "16%",
          height: isFemn ? "16%" : "17%",
        },
        BRAZO_DERECHO: {
          left: isFemn ? "62%" : "64%",
          top: "39%",
          width: isFemn ? "15%" : "16%",
          height: isFemn ? "16%" : "17%",
        },
        MANO_IZQUIERDA: {
          left: isFemn ? "22%" : "20%",
          top: isFemn ? "55%" : "56%",
          width: isFemn ? "12%" : "15%",
          height: isFemn ? "5%" : "6%",
        },
        MANO_DERECHA: {
          left: isFemn ? "70%" : "67%",
          top: isFemn ? "55%" : "56%",
          width: isFemn ? "12%" : "15%",
          height: isFemn ? "5%" : "6%",
        },
        PIERNA_IZQUIERDA: {
          left: isFemn ? "37%" : "38%",
          top: isFemn ? "50%" : "52%",
          width: "14%",
          height: isFemn ? "29%" : "30%",
        },
        PIERNA_DERECHA: {
          left: isFemn ? "50%" : "52%",
          top: isFemn ? "50%" : "52%",
          width: "14%",
          height: isFemn ? "29%" : "30%",
        },
        PIE_IZQUIERDO: {
          left: isFemn ? "36%" : "38%",
          top: isFemn ? "79%" : "82%",
          width: "15%",
          height: isFemn ? "4%" : "5%",
        },
        PIE_DERECHO: {
          left: "52%",
          top: isFemn ? "79%" : "82%",
          width: "15%",
          height: isFemn ? "4%" : "5%",
        },
      };
    }
  } else {
    if (view) {
      bodyParts = {
        CABEZA: {
          left: "44%",
          top: isFemn ? "23%" : "20%",
          width: "12%",
          height: isFemn ? "11%" : "13%",
        },
        TORSO: {
          left: isFemn ? "45%" : "45%",
          top: isFemn ? "34%" : "33%",
          width: isFemn ? "10%" : "10%",
          height: isFemn ? "15%" : "14%",
        },
        BRAZO_IZQUIERDO: {
          left: isFemn ? "54%" : "55%",
          top: isFemn ? "34%" : "33%",
          width: isFemn ? "7%" : "6%",
          height: isFemn ? "17%" : "18%",
        },
        BRAZO_DERECHO: {
          left: isFemn ? "39%" : "39%",
          top: isFemn ? "34%" : "33%",
          width: isFemn ? "7%" : "6%",
          height: isFemn ? "17%" : "18%",
        },
        MANO_IZQUIERDA: {
          left: isFemn ? "57.5%" : "58%",
          top: isFemn ? "51%" : "51%",
          width: "4%",
          height: "5%",
        },
        MANO_DERECHA: {
          left: isFemn ? "38.5%" : "37%",
          top: isFemn ? "51%" : "51%",
          width: "4%",
          height: "5%",
        },
        PIERNA_IZQUIERDA: {
          left: "50%",
          top: isFemn ? "49%" : "47%",
          width: "6%",
          height: isFemn ? "28%" : "33%",
        },
        PIERNA_DERECHA: {
          left: "44%",
          top: isFemn ? "49%" : "47%",
          width: "6%",
          height: isFemn ? "28%" : "33%",
        },
        PIE_IZQUIERDO: {
          left: "50%",
          top: isFemn ? "77%" : "80%",
          width: "6%",
          height: isFemn ? "6%" : "5%",
        },
        PIE_DERECHO: {
          left: "44%",
          top: isFemn ? "77%" : "80%",
          width: "6%",
          height: isFemn ? "6%" : "5%",
        },
      };
    } else {
      bodyParts = {
        CABEZA: {
          left: isFemn ? "42%" : "38%",
          top: isFemn ? "30%" : "28%",
          width: isFemn ? "17%" : "25%",
          height: isFemn ? "9%" : "11%",
        },
        TORSO: {
          left: isFemn ? "39%" : "37%",
          top: "39%",
          width: isFemn ? "23%" : "26%",
          height: isFemn ? "11%" : "13%",
        },
        BRAZO_IZQUIERDO: {
          left: isFemn ? "62%" : "63%",
          top: "39%",
          width: isFemn ? "15%" : "16%",
          height: isFemn ? "16%" : "17%",
        },
        BRAZO_DERECHO: {
          left: isFemn ? "24%" : "21%",
          top: "39%",
          width: isFemn ? "15%" : "16%",
          height: isFemn ? "16%" : "17%",
        },
        MANO_IZQUIERDA: {
          left: "70%",
          top: isFemn ? "55%" : "56%",
          width: isFemn ? "12%" : "15%",
          height: isFemn ? "5%" : "6%",
        },
        MANO_DERECHA: {
          left: isFemn ? "22%" : "16%",
          top: isFemn ? "55%" : "56%",
          width: isFemn ? "12%" : "15%",
          height: isFemn ? "5%" : "6%",
        },
        PIERNA_IZQUIERDA: {
          left: "50%",
          top: isFemn ? "50%" : "52%",
          width: "14%",
          height: isFemn ? "29%" : "30%",
        },
        PIERNA_DERECHA: {
          left: isFemn ? "37%" : "36%",
          top: isFemn ? "50%" : "52%",
          width: "14%",
          height: isFemn ? "29%" : "30%",
        },
        PIE_IZQUIERDO: {
          left: isFemn ? "52%" : "51%",
          top: isFemn ? "79%" : "82%",
          width: "15%",
          height: isFemn ? "4%" : "5%",
        },
        PIE_DERECHO: {
          left: isFemn ? "36%" : "34%",
          top: isFemn ? "79%" : "82%",
          width: "15%",
          height: isFemn ? "4%" : "5%",
        },
      };
    }
  }

  const cuerpoBackend =
    typeof visita.cuerpo === "string"
      ? JSON.parse(visita.cuerpo)
      : visita.cuerpo || {};

  useEffect(() => {
    setUrl(
      isBack
        ? isFemn
          ? "/images/imageCorporalFBack.jpg"
          : "/images/imageCorporalMBack.jpg"
        : isFemn
        ? "/images/imageCorporalFFront.jpg"
        : "/images/imageCorporalMFront.JPG"
    );
    const img = new Image();
    img.src = url;

    img.onload = () => {
      setSizeImage({
        width: img.width / 3,
        height: img.height / 6,
      });
    };
  }, [isBack]);

  useEffect(() => {
    const sideData = cuerpoBackend[isBack ? "back" : "front"] || {};
    if (sideData && Object.keys(sideData).length > 0) {
      const flatPoints = Object.entries(sideData).flatMap(([key, value]) => {
        const getPoints = () => {
          const { left, top, width, height } = bodyParts[key];
          return {
            x: (parseFloat(left) * 5) / 100,
            y: (parseFloat(top) * 12) / 100,
            width: sizeImage.height * (parseFloat(width) / 100),
            height: sizeImage.width * (parseFloat(height) / 100),
          };
        };
        const { x: offsetX, y: offsetY, width, height } = getPoints();
        const percentBody = view
          ? {
              CABEZA: {
                x_percent: 0.87,
                y_percent: 1.45,
                diameter_percent: 1.14,
                x_canva: 0,
                y_canva: 0,
                width: "130%",
                height: "100%",
              },
              TORSO: {
                x_percent: 0.65,
                y_percent: 0.8,
                diameter_percent: 1.4,
                x_canva: 0,
                y_canva: 0,
                width: "133%",
                height: "100%",
              },
              BRAZO_IZQUIERDO: {
                x_percent: 0.42,
                y_percent: 0.46,
                diameter_percent: 0.5,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
              BRAZO_DERECHO: {
                x_percent: 0.42,
                y_percent: 0.46,
                diameter_percent: 0.5,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
              MANO_IZQUIERDA: {
                x_percent: 0.75,
                y_percent: 2.01,
                diameter_percent: 0.5,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
              MANO_DERECHA: {
                x_percent: 0.75,
                y_percent: 2.01,
                diameter_percent: 0.5,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
              PIERNA_IZQUIERDA: {
                x_percent: 0.65,
                y_percent: 1.17,
                diameter_percent: 1.45,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
              PIERNA_DERECHA: {
                x_percent: 0.65,
                y_percent: 1.17,
                diameter_percent: 1.45,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
              PIE_IZQUIERDO: {
                x_percent: 0.97,
                y_percent: 2.85,
                diameter_percent: 0.45,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
              PIE_DERECHO: {
                x_percent: 0.97,
                y_percent: 2.85,
                diameter_percent: 0.45,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
            }
          : {
              CABEZA: {
                x_percent: 1.05,
                y_percent: 2.45,
                diameter_percent: 1.14,
                x_canva: 0,
                y_canva: 0,
                width: "130%",
                height: "100%",
              },
              TORSO: {
                x_percent: 0.85,
                y_percent: 1.65,
                diameter_percent: 1.4,
                x_canva: 0,
                y_canva: 0,
                width: "133%",
                height: "100%",
              },
              BRAZO_IZQUIERDO: {
                x_percent: 0.85,
                y_percent: 0.51,
                diameter_percent: 0.5,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
              BRAZO_DERECHO: {
                x_percent: 0.24,
                y_percent: 0.58,
                diameter_percent: 0.5,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
              MANO_IZQUIERDA: {
                x_percent: 1.1,
                y_percent: 2.01,
                diameter_percent: 0.5,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
              MANO_DERECHA: {
                x_percent: 0.3,
                y_percent: 2.01,
                diameter_percent: 0.5,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
              PIERNA_IZQUIERDA: {
                x_percent: 1,
                y_percent: 1.3,
                diameter_percent: 1.45,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
              PIERNA_DERECHA: {
                x_percent: 0.72,
                y_percent: 1.3,
                diameter_percent: 1.45,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
              PIE_IZQUIERDO: {
                x_percent: 1,
                y_percent: 2.85,
                diameter_percent: 0.45,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
              PIE_DERECHO: {
                x_percent: 0.77,
                y_percent: 2.85,
                diameter_percent: 0.45,
                x_canva: 0,
                y_canva: 0,
                width: "100%",
                height: "100%",
              },
            };
        if (Array.isArray(value.puntos)) {
          return {
            part: key,
            x_canva: percentBody[key].x_canva,
            y_canva: percentBody[key].y_canva,
            width: percentBody[key].width,
            height: percentBody[key].height,
            points: value.puntos.map((point) => {
              console.log("point", point);
              return {
                x: (point.x / offsetX + height) * percentBody[key].x_percent,
                y: (point.y / offsetY + width) * percentBody[key].y_percent,
                size: point.diametro * percentBody[key].diameter_percent,
                color: point.color ?? "red",
              };
            }),
          };
        }
        return [];
      });
      setPoints(flatPoints);
    } else {
      setPoints([]);
    }
  }, [isBack, visita]);

  return (
    <div width={"w-full"}>
      <div>
        <span>
          Presione en cualquiera de las partes para registrar un diagnostico.
        </span>
      </div>
      <div className="flex content-center flex-col">
        <div className="flex flex-col span">
          <div className="flex justify-center">
            {/* Imagen del cuerpo */}
            <img
              src={url}
              alt="Cuerpo humano"
              className={`${
                view ? "w-1/3 h-1/6" : "w-full h-auto"
              } object-cover border border-dashed border-subMain`}
            />

            {/* Divs sobrepuestos */}
            {Object.keys(bodyParts).map((part) => (
              <BodyOverlayViewer
                part={part}
                styles={styles}
                bodyParts={bodyParts}
                points={points.find((point) => point.part === part)}
                setOpenSubModal={setOpenSubModal}
                setSelectPart={setSelectPart}
              />
            ))}
          </div>
        </div>

        <Button
          label={!isBack ? "Atrás" : "Frontal"}
          onClick={() => setIsBack(!isBack)}
          Icon={!isBack ? FaArrowRight : FaArrowLeft}
        />
      </div>
      {openSubModal && (
        <ModalPartOfBody
          isOpen={openSubModal}
          closeModal={() => setOpenSubModal(false)}
          isBack={isBack}
          isFemn={isFemn}
          part={selectPart}
          visita={visita}
          setVisita={setVisita}
          functions={functions}
          view={view}
        />
      )}
    </div>
  );
};

export const CorporalModal = ({
  visita,
  closeModal,
  isOpen,
  title,
  functions,
}) => {
  return (
    <Modal closeModal={closeModal} isOpen={isOpen} title={title}>
      <DivCorporal visita={visita} functions={functions} />
    </Modal>
  );
};

const ModalPartOfBody = ({
  closeModal,
  isOpen,
  part,
  visita,
  setVisita,
  isBack,
  isFemn,
  functions,
  view,
}) => {
  const [title, setTitle] = useState("");
  const [path, setPath] = useState("");
  const [FrontBackBody, setFrontBackBody] = useState({});
  const [areaAfectada, setAreaAfectada] = useState("");
  const [diagnostico, setDiagnostico] = useState("");
  const [drawnPoints, setDrawnPoints] = useState([]);
  const [visitaActual, setVisitaActual] = useState(visita);
  const [suggestions, setSuggestions] = useState([]); // Nuevo estado para las sugerencias
  const validParts = [
    "CABEZA",
    "TORSO",
    "BRAZO_IZQUIERDO",
    "BRAZO_DERECHO",
    "PIERNA_IZQUIERDA",
    "PIERNA_DERECHA",
  ];
  const handleDiagnosticoChange = (e) => {
    const value = e.target.value;
    setDiagnostico(value);
    if (value.length > 1) {
      // Reducimos el mínimo de caracteres para buscar también por código
      const normalizedValue = value.toLowerCase();
      const filteredEnfermedades = Enfermedades.filter((enfermedad) => {
        // Verifica si el valor ingresado coincide con el nombre (enfermedad) o el código (id)
        return (
          enfermedad?.enfermedad?.toLowerCase().includes(normalizedValue) ||
          enfermedad?.id?.toLowerCase().includes(normalizedValue)
        );
      });
      // Formatea las sugerencias para mostrar tanto el código como el nombre
      const formattedSuggestions = filteredEnfermedades.map((enfermedad) => ({
        label: `${enfermedad.id} - ${enfermedad.enfermedad}`,
        code: enfermedad.id, // Opcional: guardar el código por si lo necesitas después
        name: enfermedad.enfermedad, // Opcional: guardar el nombre por si lo necesitas después
      }));
      setSuggestions(formattedSuggestions);
    } else {
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setDiagnostico(suggestion.label);
    setSuggestions([]);
  };

  let currentSubParts = [];
  switch (part) {
    case "CABEZA":
      currentSubParts = [
        { id: 1, name: " " },
        { id: 2, name: isBack ? "Nuca" : "Frontal" },
        { id: 3, name: "Ojo Izquierdo" },
        { id: 4, name: "Ojo Derecho" },
        { id: 5, name: "Nariz" },
        { id: 6, name: "Boca" },
        { id: 7, name: "Oreja Izquierda" },
        { id: 8, name: "Oreja Derecha" },
        { id: 9, name: "Frente" },
        { id: 10, name: "Mejilla Izquierda" },
        { id: 11, name: "Mejilla Derecha" },
      ];
      break;
    case "TORSO":
      currentSubParts = [
        { id: 1, name: " " },
        { id: 2, name: isBack ? "Espalda" : "Pecho" },
        { id: 3, name: "Hombro Izquierdo" },
        { id: 4, name: "Hombro Derecho" },
        { id: 5, name: "Cintura" },
        { id: 6, name: "Esternón" },
        { id: 7, name: "Costilla Izquierda" },
        { id: 8, name: "Costilla Derecha" },
        { id: 9, name: "Omóplato Izquierdo" },
        { id: 10, name: "Omóplato Derecho" },
      ];
      break;
    case "BRAZO_IZQUIERDO":
      currentSubParts = [
        { id: 1, name: " " },
        { id: 2, name: isBack ? "Brazo Izquierdo" : "Frontal" },
        { id: 3, name: "Codo Izquierdo" },
        { id: 4, name: "Muñeca Izquierda" },
        { id: 6, name: "Codo Izquierdo" },
        { id: 7, name: "Hombro Izquierdo" },
        { id: 8, name: "Axila Izquierda" },
        { id: 9, name: "Antebrazo Izquierdo" },
        { id: 10, name: "Bíceps Izquierdo" },
        { id: 11, name: "Tríceps Izquierdo" },
      ];
      break;
    case "BRAZO_DERECHO":
      currentSubParts = [
        { id: 1, name: " " },
        { id: 2, name: isBack ? "Brazo Derecho" : "Frontal" },
        { id: 3, name: "Codo Derecho" },
        { id: 4, name: "Muñeca Derecha" },
        { id: 6, name: "Codo Derecho" },
        { id: 7, name: "Hombro Derecho" },
        { id: 8, name: "Axila Derecha" },
        { id: 9, name: "Antebrazo Derecho" },
        { id: 10, name: "Bíceps Derecho" },
        { id: 11, name: "Tríceps Derecho" },
      ];
      break;
    case "MANO_IZQUIERDA":
      currentSubParts = [
        { id: 1, name: " " },
        { id: 2, name: isBack ? "Mano Izquierda" : "Frontal" },
        { id: 3, name: "Pulgar Izquierdo" },
        { id: 4, name: "Índice Izquierdo" },
        { id: 5, name: "Medio Izquierdo" },
        { id: 6, name: "Anular Izquierdo" },
        { id: 7, name: "Meñique Izquierdo" },
        { id: 8, name: "Palma Izquierda" },
        { id: 9, name: "Muñeca Izquierda" },
        { id: 10, name: "Dorso de la Mano Izquierda" },
        { id: 11, name: "Articulación de la Mano Izquierda" },
      ];
      break;
    case "MANO_DERECHA":
      currentSubParts = [
        { id: 1, name: " " },
        { id: 2, name: isBack ? "Mano Derecha" : "Frontal" },
        { id: 3, name: "Pulgar Derecho" },
        { id: 4, name: "Índice Derecho" },
        { id: 5, name: "Medio Derecho" },
        { id: 6, name: "Anular Derecho" },
        { id: 7, name: "Meñique Derecho" },
        { id: 8, name: "Palma Derecha" },
        { id: 9, name: "Muñeca Derecha" },
        { id: 10, name: "Dorso de la Mano Derecha" },
        { id: 11, name: "Articulación de la Mano Derecha" },
      ];
      break;
    case "PIERNA_IZQUIERDA":
      currentSubParts = [
        { id: 1, name: " " },
        { id: 2, name: isBack ? "Muslo Izquierdo" : "Frontal" },
        { id: 3, name: "Rodilla Izquierda" },
        { id: 4, name: "Tobillo Izquierdo" },
        { id: 5, name: "Pantorrilla Izquierda" },
        { id: 6, name: "Tibio Peroné Izquierdo" },
        { id: 7, name: "Tobillo Izquierdo" },
        { id: 8, name: "Articulación de la Pierna Izquierda" },
      ];
      break;
    case "PIERNA_DERECHA":
      currentSubParts = [
        { id: 1, name: " " },
        { id: 2, name: isBack ? "Muslo Derecho" : "Frontal" },
        { id: 3, name: "Rodilla Derecha" },
        { id: 4, name: "Tobillo Derecho" },
        { id: 5, name: "Pantorrilla Derecha" },
        { id: 6, name: "Tibio Peroné Derecho" },
        { id: 7, name: "Tobillo Derecho" },
        { id: 8, name: "Articulación de la Pierna Derecha" },
      ];
      break;
    case "PIE_IZQUIERDO":
      currentSubParts = [
        { id: 1, name: " " },
        { id: 2, name: isBack ? "Pie Izquierdo" : "Frontal" },
        { id: 3, name: "Dedos Izquierdos" },
        { id: 4, name: "Talón Izquierdo" },
        { id: 5, name: "Planta Izquierda" },
        { id: 6, name: "Tobillo Izquierdo" },
        { id: 7, name: "Articulación de la Pierna Izquierda" },
        { id: 8, name: "Dorso del Pie Izquierdo" },
        { id: 9, name: "Articulación del Pie Izquierdo" },
        { id: 10, name: "Tobillo Izquierdo" },
        { id: 11, name: "Dedos del Pie Izquierdo" },
      ];
      break;
    case "PIE_DERECHO":
      currentSubParts = [
        { id: 1, name: " " },
        { id: 2, name: isBack ? "Pie Derecho" : "Frontal" },
        { id: 3, name: "Dedos Derechos" },
        { id: 4, name: "Talón Derecho" },
        { id: 5, name: "Planta Derecha" },
        { id: 6, name: "Tobillo Derecho" },
        { id: 7, name: "Articulación de la Pierna Derecha" },
        { id: 8, name: "Dorso del Pie Derecho" },
        { id: 9, name: "Articulación del Pie Derecho" },
        { id: 10, name: "Tobillo Derecho" },
        { id: 11, name: "Dedos del Pie Derecho" },
      ];
      break;
    default:
      currentSubParts = [];
  }

  useEffect(() => {
    const cuerpoBackend =
      typeof visita.cuerpo === "string"
        ? JSON.parse(visita.cuerpo)
        : visita.cuerpo || {};

    const sideData = cuerpoBackend[isBack ? "back" : "front"] || {};
    setFrontBackBody(sideData);

    const partData = sideData[part];

    if (partData) {
      setAreaAfectada(partData.area_afectada || "");
      setDiagnostico(partData.diagnostico || "");

      if (Array.isArray(partData.puntos) && partData.puntos.length > 0) {
        setDrawnPoints(
          partData.puntos.map((p) => ({
            x: p.x,
            y: p.y,
            size: p.diametro,
            color: p.color,
          }))
        );
      } else {
        setDrawnPoints([]);
      }
    } else {
      setAreaAfectada("");
      setDiagnostico("");
      setDrawnPoints([]);
    }

    setupPathAndTitle();
  }, [part, visita, isBack, isFemn]);

  const setupPathAndTitle = () => {
    switch (part) {
      case "CABEZA":
        if (isBack) {
          setTitle("Diagnostico Nuca");
          setPath(
            isFemn ? "/images/imageCFBNuca.jpg" : "/images/imageCMBNuca.jpg"
          );
        } else {
          setTitle("Diagnostico Rostro");
          setPath(
            isFemn ? "/images/imageCFFFace.jpg" : "/images/imageCMFFace.jpg"
          );
        }
        break;
      case "TORSO":
        if (isBack) {
          setTitle("Diagnostico Espalda");
          setPath(
            isFemn ? "/images/imageCFBBreast.jpg" : "/images/imageCMBBreast.jpg"
          );
        } else {
          setTitle("Diagnostico Pecho");
          setPath(
            isFemn ? "/images/imageCFFBreast.jpg" : "/images/imageCMFBreast.jpg"
          );
        }
        break;
      case "BRAZO_IZQUIERDO":
        setTitle("Diagnostico Brazo Izquierdo");
        if (isBack) {
          setPath(
            isFemn
              ? "/images/imageCFBArmLeft.jpg"
              : "/images/imageCMBArmLeft.jpg"
          );
        } else {
          setPath(
            isFemn
              ? "/images/imageCFFArmLeft.jpg"
              : "/images/imageCMFArmLeft.jpg"
          );
        }
        break;
      case "BRAZO_DERECHO":
        setTitle("Diagnostico Brazo Derecho");
        if (isBack) {
          setPath(
            isFemn
              ? "/images/imageCFBArmRight.jpg"
              : "/images/imageCMBArmRight.jpg"
          );
        } else {
          setPath(
            isFemn
              ? "/images/imageCFFArmRight.jpg"
              : "/images/imageCMFArmRight.jpg"
          );
        }
        break;
      case "MANO_IZQUIERDA":
        if (isBack) {
          setTitle("Diagnostico Mano Izquierda");
          setPath(
            isFemn
              ? "/images/imageCFBHandLeft.jpg"
              : "/images/imageCMBHandLeft.jpg"
          );
        } else {
          setTitle("Diagnostico Palma Izquierda");
          setPath(
            isFemn
              ? "/images/imageCFFHandLeft.jpg"
              : "/images/imageCMFHandLeft.jpg"
          );
        }
        break;
      case "MANO_DERECHA":
        if (isBack) {
          setTitle("Diagnostico Mano Derecha");
          setPath(
            isFemn
              ? "/images/imageCFBHandRight.jpg"
              : "/images/imageCMBHandRight.jpg"
          );
        } else {
          setTitle("Diagnostico Palma Derecha");
          setPath(
            isFemn
              ? "/images/imageCFFHandRight.jpg"
              : "/images/imageCMFHandRight.jpg"
          );
        }
        break;
      case "PIERNA_IZQUIERDA":
        setTitle("Diagnostico Pierna Izquierda");
        if (isBack) {
          setPath(
            isFemn
              ? "/images/imageCFBLegLeft.png"
              : "/images/imageCMBLegLeft.png"
          );
        } else {
          setPath(
            isFemn
              ? "/images/imageCFFLegLeft.png"
              : "/images/imageCMFLegLeft.png"
          );
        }
        break;
      case "PIERNA_DERECHA":
        setTitle("Diagnostico Pierna Derecha");
        if (isBack) {
          setPath(
            isFemn
              ? "/images/imageCFBLegRight.png"
              : "/images/imageCMBLegRight.png"
          );
        } else {
          setPath(
            isFemn
              ? "/images/imageCFFLegRight.png"
              : "/images/imageCMFLegRight.png"
          );
        }
        break;
      case "PIE_IZQUIERDO":
        if (isBack) {
          setTitle("Diagnostico Pie Izquierdo");
          setPath(
            isFemn
              ? "/images/imageCFBFootLeft.jpg"
              : "/images/imageCMBFootLeft.jpg"
          );
        } else {
          setTitle("Diagnostico Planta Izquierdo");
          setPath(
            isFemn
              ? "/images/imageCFFFootLeft.jpg"
              : "/images/imageCMFFootLeft.jpg"
          );
        }
        break;
      case "PIE_DERECHO":
        if (isBack) {
          setTitle("Diagnostico Pie Derecho");
          setPath(
            isFemn
              ? "/images/imageCFBLFootRight.jpg"
              : "/images/imageCMBFootRight.jpg"
          );
        } else {
          setTitle("Diagnostico Planta Derecho");
          setPath(
            isFemn
              ? "/images/imageCFFFoots.jpg"
              : "/images/imageCMFFootRight.jpg"
          );
        }
        break;
      default:
        setPath("");
        setTitle("Diagnostico");
    }
  };

  const handleSave = () => {
    ConfirmationAlert({
      title: "Registrar examen corporal",
      text: "¿Estas seguro de guardar los cambios?",
      onAccept: () => {
        let cuerpoObject =
          typeof visita.cuerpo === "string"
            ? JSON.parse(visita.cuerpo)
            : visita.cuerpo || {};

        const currentSide = cuerpoObject[isBack ? "back" : "front"] || {};

        const newCuerpo = {
          ...cuerpoObject,
          [isBack ? "back" : "front"]: {
            ...currentSide,
            [part]: {
              area_afectada: areaAfectada,
              diagnostico: diagnostico,
              puntos: drawnPoints.map((p) => ({
                x: p.x,
                y: p.y,
                diametro: p.size,
                color: p.color,
              })),
            },
          },
        };
        const updatedVisita = {
          ...visita,
          cuerpo: JSON.stringify(newCuerpo), // Guardar como string para uniformidad
        };

        console.log(updatedVisita);
        const newData = functions.dispatch(
          updateVisitasById(updatedVisita, visita.id)
        );
        if (newData?.error) {
          toast.error(`No se pudo crear el antecedente: ${newData.error}`);
        } else {
          setVisita(updatedVisita);
          toast.success("Examen guardado con exito!");
        }
      },
    });

    closeModal();
  };

  const handleAreaAfectadaChange = (e) => {
    setAreaAfectada(e.target.value);
  };

  // const handleDiagnosticoChange = (e) => {
  //   setDiagnostico(e.target.value);
  // };

  const handleSubPartSelect = (selectedValue) => {
    setAreaAfectada(selectedValue);
  };
  return (
    <Modal
      closeModal={closeModal}
      isOpen={isOpen}
      title={title}
      width={"min-w-3xl max-w-3xl"}
    >
      <div className="flex flex-row w-max-1/4">
        <div className="w-1/3 m-4">
          <DrawableImagePoints
            imageSrc={path}
            onPointDrawn={(pointData) => {
              setDrawnPoints((prevPoints) => [...prevPoints, pointData]);
            }}
            part={part}
            preloadedPoints={drawnPoints}
          />
        </div>
        <div className="flex flex-col flex-1 w-full">
          {/* Form Fields */}
          <div className="mb-4">
            <>
              <label className="block text-black text-sm mb-2">
                Área afectada
              </label>
              <div className="relative">
                <select
                  className="w-full text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain appearance-none"
                  value={
                    areaAfectada || FrontBackBody[part]?.area_afectada || ""
                  }
                  onChange={(e) => handleSubPartSelect(e.target.value)}
                >
                  {currentSubParts.map((option) => (
                    <option key={option.id} value={option.name}>
                      {option.name}
                    </option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <BiChevronDown className="text-xl" />
                </div>
              </div>
            </>
          </div>

          <div className="mb-4">
            <DinamicInputWithSearchBar2
              label={"Diagnostico"}
              value={diagnostico}
              onChange={handleDiagnosticoChange}
              suggestions={suggestions}
              onSuggestionClick={handleSuggestionClick}
              color={"text-textGray"}
            />
          </div>

          {/* Action Buttons */}
          <div className="flex flex-row space-x-4 w-full">
            <button
              className="flex items-center justify-center px-4 py-2 bg-subMain text-white rounded-md hover:bg-main transition"
              onClick={handleSave}
            >
              <FaSave className="mr-2" />
              Guardar
            </button>
            <button
              className="flex items-center justify-center px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition"
              onClick={() => closeModal(false)}
            >
              <FaTimesCircle className="mr-2" />
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
